import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Tick } from '../../helpers/icon-dictionary';
import styles from './index.scss';
import Button from '../button/index';
import { BOX_LIGHT } from '../button/variants';
import SvgIcon from '../svg-icon/svg-icon';
import messages from './messages';

class AddClassConfirmation extends Component {
    constructor(props) {
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
    }

    handleOnClose = () => {
        const { onAddClassCloseModal } = this.props;
        onAddClassCloseModal();
    }

    render() {
        const { classroom, intl } = this.props;
        return (
            <div>
                <div className={styles.addClassComponent}>
                    <div className={styles.icon}>
                        <SvgIcon icon={Tick} />
                    </div>
                    <div className={styles.header}>
                        <span>{classroom.name}</span> {intl.formatMessage(messages.addClassConfirmation)}
                    </div>
                    <Button
                        handleOnClick={this.handleOnClose}
                        icon={Tick}
                        label={intl.formatMessage(messages.done)}
                        variant={BOX_LIGHT} />
                </div>
            </div>
        );
    }
}

AddClassConfirmation.propTypes = {
    classroom: PropTypes.object,
    intl: intlShape.isRequired,
    onAddClassCloseModal: PropTypes.func
};

export default injectIntl(styleable(styles)(AddClassConfirmation));




// WEBPACK FOOTER //
// ./app/components/add-class/confirmation.js